import React, {useState} from 'react';
import {Layout} from '../components/common/Layout';
import {AgreementForm} from "../components/agreement/AgreementForm";
import {SelectPackage} from "../components/agreement/SelectPackage";
import {useNavigate} from "react-router-dom";
import {useMutation} from "@apollo/client";
import {UPDATE_AGREEMENT} from "../api/lead/updateAgreementAndPackage";

export const Agreement = () => {
    const [step, setStep] = useState<'AGREEMENT' | 'SELECT-PACKAGE'>('SELECT-PACKAGE')
    const [loading, setLoading] = useState(false)
    const [selectedPackageId, setSelectedPackageId] = useState<string>()

    const navigate = useNavigate();

    const [name, setName] = useState('')
    const [confirmName, setConfirmName] = useState('')

    const [updateAgreement, {loading: isUpdateLoading}] = useMutation(UPDATE_AGREEMENT)

    const onSelect = (packageId: string) => {
        setSelectedPackageId(packageId)
        setStep('AGREEMENT')
    }

    const onSubmit = async () => {
        if (!selectedPackageId) return

        const {errors} = await updateAgreement({variables: {
            input: {
                packageId: selectedPackageId,
                agreementName: name
            }
        }})

        if (errors === undefined || errors.length === 0) {
            navigate('/my-application')
        }
    }

    return (
        <Layout title={step === 'AGREEMENT' ? "Agreement" : "Packages"} showHeader isLoading={loading || isUpdateLoading}>
            {step === 'AGREEMENT' && (
                <AgreementForm
                    confirmName={confirmName}
                    name={name}
                    onSubmit={onSubmit}
                    setConfirmName={setConfirmName}
                    setName={setName}
                />
            )}

            {step === 'SELECT-PACKAGE' && (
                <SelectPackage
                    setLoading={setLoading}
                    onSelect={onSelect}
                />
            )}
        </Layout>
    )
}
